import { DateTime } from 'luxon'
import { RoleCategoryId } from '../dashboard/careTeam/types'
import { FeedEvent } from '../dashboard/chat/useChatEventFeed'

export const EXAMPLE_PROVIDER = { id: 'tour-example-provider', name: 'Maija Meikäläinen' }

const otherRoleFor = (viewerRole: RoleCategoryId | null): { role: RoleCategoryId; track: string } =>
  viewerRole === 'nutritionist' ? { role: 'coach', track: 'activity' } : { role: 'nutritionist', track: 'nutrition' }

export const exampleProviderRole = (viewerRole: RoleCategoryId | null): RoleCategoryId => otherRoleFor(viewerRole).role

const at = (daysAgo: number, hour: number, minute = 0) =>
  DateTime.now().minus({ days: daysAgo }).set({ hour, minute, second: 0, millisecond: 0 }).toISO() ?? ''

const activity = (
  overrides: Pick<Extract<FeedEvent, { kind: 'activity' }>, 'id' | 'timestamp' | 'label' | 'category'> &
    Partial<Extract<FeedEvent, { kind: 'activity' }>>
): FeedEvent => ({
  kind: 'activity',
  detail: null,
  activityType: 'contentCompletion',
  responseID: null,
  context: null,
  facts: null,
  iconCategory: 'DEFAULT',
  continued: false,
  isCompleted: true,
  unread: false,
  ...overrides,
})

const chat = (
  overrides: Pick<Extract<FeedEvent, { kind: 'chat' }>, 'id' | 'timestamp' | 'text' | 'category'> &
    Partial<Extract<FeedEvent, { kind: 'chat' }>>
): FeedEvent => ({
  kind: 'chat',
  fromPatient: false,
  authorCoachId: null,
  channel: 'inApp',
  attachments: [],
  linkedTo: null,
  unread: false,
  ...overrides,
})

// Oldest first, as `useChatEventFeed` orders a real feed.
export const exampleFeedEvents = (coachUid: string, viewerRole: RoleCategoryId | null): FeedEvent[] => {
  const other = otherRoleFor(viewerRole)

  return [
    activity({
      id: 'example:completion',
      timestamp: at(2, 9, 12),
      label: 'Sleep basics',
      activityType: 'lessonResponse',
      responseID: 'example:response',
      category: viewerRole ?? 'system',
    }),
    activity({
      id: 'example:other-track',
      timestamp: at(2, 13, 40),
      label: 'Balanced breakfast',
      category: other.track,
    }),
    chat({
      id: 'example:patient-1',
      timestamp: at(1, 18, 5),
      text: 'Hi! I finished the sleep lesson. Could we talk about my evening routine next time?',
      fromPatient: true,
      category: 'patient',
    }),
    chat({
      id: 'example:mine',
      timestamp: at(0, 9, 15),
      text: 'Great job finishing it! Yes, let’s go through your evening routine on Thursday.',
      authorCoachId: coachUid,
      category: viewerRole ?? 'system',
    }),
    chat({
      id: 'example:patient-2',
      timestamp: at(0, 9, 40),
      text: 'Thursday works. Thank you!',
      fromPatient: true,
      category: 'patient',
    }),
  ]
}
